module.exports = __webpack_public_path__ + "img/asian-salad-1.9df0ef2e.jpg";